package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

//val CoverButtonStyle = CssStyle {
//    base {
//        Modifier
//            .backgroundImage(
//                gradient = linearGradient(
//                    from = Colors.DarkBlue,
//                    to = Colors.linear,
//                    dir = LinearGradient.Direction.ToRight
//                )
//            )
//            .color(Colors.White)
//            .border(0.px, LineStyle.Solid, Colors.DarkBlue)
//            .borderRadius(22.px)
//
//
//
//    }
//
//
//    Breakpoint.MD {
//        Modifier
//            .fontSize(35.px)
//            .borderRadius(44.px)
//    }
//    hover{
//        Modifier
//            .styleModifier {
//                property("background-image", "none")   // ← supprime le gradient
//                property("background-color", "transparent") // ← fond transparent
//                property("transition", "all 200ms ease")
//            }
//            .color(Colors.DarkBlue)
//            .border(2.px, LineStyle.Solid, Colors.DarkBlue)
//            .borderRadius(44.px)
//    }
//}
//
//val HeroBannerStyle = CssStyle {
//    base          {
//        Modifier
//            .styleModifier {
//                property("background-position", "center" )
//            }
//            .height(250.px)
//    }
//    Breakpoint.MD {
//        Modifier
//            .styleModifier {
//                property("background-position", "left center")
//            }
//            .height(850.px)
//    }
//}
//
//val HeroContentPaddingStyle = CssStyle {
//    base          { Modifier.padding(left = 20.px) }
//    Breakpoint.MD { Modifier.padding(left = 90.px) }
//}
//
//val HeroTextColumnStyle = CssStyle {
//    base          { Modifier.maxWidth(400.px) }
//    Breakpoint.MD { Modifier.maxWidth(800.px) }
//}
//
//val HeroTitleStylecss = CssStyle {
//    base          { Modifier.fontSize(16.px).margin(bottom = 20.px) }
//    Breakpoint.MD { Modifier.fontSize(50.px).margin(bottom = 60.px) }
//}
//
//val HeroSubtitleStylecss = CssStyle {
//    base          { Modifier.fontSize(14.px).margin(bottom = 10.px) }
//    Breakpoint.MD { Modifier.fontSize(30.px).margin(bottom = 55.px) }
//}
//
//val MotiveButtonStyle = CssStyle {
//    base          {
//        Modifier
//            .borderRadius(22.px)
//            .padding(topBottom = 10.px, leftRight = 10.px)
//
//    }
//    Breakpoint.MD {
//        Modifier
//            .borderRadius(44.px)
//            .padding(topBottom = 40.px, leftRight = 40.px)
//    }
//}

val CoverButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundImage(
                gradient = linearGradient(
                    from = Colors.DarkBlue,
                    to = Colors.linear,
                    dir = LinearGradient.Direction.ToRight
                )
            )
            .color(Colors.White)
            .border(0.px, LineStyle.Solid, Colors.DarkBlue)
            .borderRadius(22.px)
    }

    Breakpoint.MD {
        Modifier
            .fontSize(20.px) // Adapté pour correspondre au responsive global
            .borderRadius(44.px)
    }
    hover {
        Modifier
            .styleModifier {
                property("background-image", "none")
                property("background-color", "transparent")
                property("transition", "all 200ms ease")
            }
            .color(Colors.DarkBlue)
            .border(2.px, LineStyle.Solid, Colors.DarkBlue)
            .borderRadius(44.px)
    }
}

val HeroBannerStyle = CssStyle {
    base {
        Modifier
            .height(250.px)
            .styleModifier {
                property("background-position", "center center")
                property("background-size", "cover")
            }
    }
    Breakpoint.MD {
        Modifier
            .styleModifier {
                property("height", "auto") // ← Déclaré sous forme de propriété CSS standard
                property("background-position", "center center")
                property("background-size", "100% 100%")
                property("aspect-ratio", "1920 / 750")
            }
    }
}

val HeroContentPaddingStyle = CssStyle {
    base { Modifier.padding(left = 20.px) }
    Breakpoint.MD { Modifier.padding(left = 7.percent) }
}

val HeroTextColumnStyle = CssStyle {
    base { Modifier.maxWidth(100.percent) }
    Breakpoint.MD { Modifier.maxWidth(45.percent) }
}

val HeroTitleStylecss = CssStyle {
    base { Modifier.fontSize(16.px).margin(bottom = 20.px) }
    Breakpoint.MD {
        Modifier
            .styleModifier { property("font-size", "clamp(24px, 2.5vw, 44px)") }
            .margin(bottom = 30.px)
    }
}

val HeroSubtitleStylecss = CssStyle {
    base { Modifier.fontSize(14.px).margin(bottom = 10.px) }
    Breakpoint.MD {
        Modifier
            .styleModifier { property("font-size", "clamp(14px, 1.4vw, 24px)") }
            .margin(bottom = 40.px)
    }
}

val MotiveButtonStyle = CssStyle {
    base {
        Modifier
            .borderRadius(22.px)
            .padding(topBottom = 10.px, leftRight = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .borderRadius(44.px)
            .padding(topBottom = 40.px, leftRight = 40.px)
    }
}